import { useState, type ReactNode } from 'react';
import { SafetyAlertDialog } from './SafetyAlertDialog';

interface ISafetyAlertDialogHandle {
  /** Pass to each `SafetyAlertRow` as `onOpen`. */
  openAlert: (eventId: string) => void;
  /** Render once, next to the rows. */
  alertDialog: ReactNode;
}

/**
 * The open-alert state for a list of safety alert rows. It lives in the list,
 * not the row: live alerts reorder the list, and a row pushed out of view would
 * take an open dialog down with it.
 */
export function useSafetyAlertDialog(): ISafetyAlertDialogHandle {
  const [openEventId, setOpenEventId] = useState<string | null>(null);
  return {
    openAlert: setOpenEventId,
    alertDialog: openEventId && (
      <SafetyAlertDialog eventId={openEventId} onClose={() => setOpenEventId(null)} />
    ),
  };
}
